PJQ.views.drawings.DrawingBatchModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-New-Drawing-Batch'),
        step: 1,
        subTemplates: {
            batchHeader: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Batch-Header'),
            drawingTags: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Tags'),
            drawingDetailHeader: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Upload-Drawing-Detail-Header'),
            sortDrawings: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Sort-Drawings')
        },
        isShowCloseButton: true
    },
    events: {
        'click .btn-next-step': 'nextStep',
        'click .btn-prev-step': 'previousStep',
        'change .checkbox-new-version': 'useNewVersion',
        'change .checkbox-existing-version': 'useExistingVersion',
        'click .existing-version': 'existingVersionSelected',
        'keyup .input-version-name': 'versionNameChanged',
        'click .select-batch-drawing': 'viewBatchDrawing',
        'click .btn-drawing-rotate-90': 'rotateBatchDrawing90Clicked',
        'click .btn-drawing-rotate-180': 'rotateBatchDrawing180Clicked',
        'click .btn-drawing-rotate-270': 'rotateBatchDrawing270Clicked',
        'click .btn-drawing-delete': 'deleteBatchDrawing',
        'click .btn-save': 'save',
        'click .btn-publish': 'publish',
        'click .btn-cancel': 'cancel',
        'click .btn-close': 'closeModal',
        'blur .input-drawing-name,.input-drawing-title,.input-drawing-tag': 'drawingBlur',
        'focus .input-drawing-name,.input-drawing-title,.input-drawing-tag': 'drawingFocus',
        'keydown .input-drawing-name': 'drawingNameKeydown',
        'keyup .input-drawing-name': 'drawingNameChanged',
        'keydown .input-drawing-title': 'drawingTitleKeydown',
        'keyup .input-drawing-title': 'drawingTitleChanged',
        'keydown .input-drawing-tag': 'drawingTagKeydown',
        'keyup .input-drawing-tag': 'drawingTagChanged',
        'click .btn-add-drawing-tag': 'addDrawingTagClicked',
        'click .btn-delete-tag': 'deleteTagClicked',
        'click .btn-upload-log': 'viewUploadLog',
        'change .checkbox-add-current-set': 'addToCurrentSetChanged',
        'change .checkbox-add-all-current-set': 'addAllToCurrentSetChanged',
        'change .checkbox-replace-current-set': 'replaceCurrentSetChanged',
        'change .cb-replace-existing-drawing': 'replaceExistingDrawingChanged',
        'click .btn-highlight-area': 'highlightArea'
    },
    highlightArea: function (e) {
        let drawing = this.model.drawings.models[0];
        new PJQ.views.drawings.DrawingAreaHighlight({
            model: drawing,
            batch: this.model,
            versions: this.options.versions,
            onSave: _.bind(function (result) {
                this.model.set({
                    nameArea: result.layers.name,
                    titleArea: result.layers.title
                });
                this.model.patch(this.model.attributes, {
                    success: _.bind(function () {
                        this.options.step = 3;
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.drawings.DrawingBatch({
                projectId: this.options.project.id
            });

            if (this.options.version != null) {
                this.model.version = this.options.version;
                this.options.step = 2;
            }
        } else if (this.model.id > 0) {
            // we are continuing an existing upload
            this.options.step = 4;
            this.model.fetch({
                success: _.bind(function () {
                    this.setCurrentSetDefaults();
                    this.render();
                }, this)
            });
        }
    },
    setCurrentSetDefaults: function () {
        this.options.currentSetDefault = !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWINGS_CURRENT_SET_DEFAULT_OFF);
        if (this.model) {
            _.each(this.model.drawings.models, function (drawing) {
                drawing.set("isCurrentSet", this.options.currentSetDefault);
            }, this);
        }
    },
    beforeRender: function () {
        this.options.fitHeight = this.options.step === 5;

        if (this.options.step === 4) {
            let publishedIds = [];
            _.each(this.model.drawings.models, function (drawing) {
                if (drawing.get('isPublished')) {
                    publishedIds.push(drawing.id);
                }
            });
            this.model.drawings.remove(publishedIds);
        }
    },
    getWidth: function () {
        let result;
        if (this.options.step === 4) {
            result = {
                minWidth: 400,
                maxWidth: '80%',
                width: 1200
            };
        } else {
            result = {
                minWidth: 600,
                maxWidth: this.options.maxWidth,
                width: this.options.width
            };
        }
        return result;
    },
    renderData: function () {
        return {
            model: this.model,
            versions: this.options.versions,
            step: this.options.step
        };
    },
    afterRender: function () {
        switch (this.options.step) {
            case 1:
                this.initVersionSelect();
                break;
            case 2:
                this.initFileUpload();
                break;
            case 3:
                this.initBatchWait();
                break;
            case 4:
                if (this.model.isFetched) {
                    this.initBatchPublish();
                }
                break;
            case 5:
                this.initBatchSort();
                break;
        }
    },
    initVersionSelect: function () {
        this.$(".input-version-name").focus();
        new PJQ.inputs.Datepicker({
            el: this.$('.input-version-date-issued'),
            isShowTimezone: false,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
            },
            onChange: _.bind(function (newDate) {
                this.model.version.set('issuedOn', newDate);
                this.validateNewVersion();
            }, this)
        });
        this.useNewVersion();
    },
    initFileUpload: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.version-file-uploader'),
            collection: this.model.uploads,
            allowedExtensions: ['pdf', 'tif', 'tiff'],
            style: 'list',
            onSuccess: _.bind(this.dataChanged, this),
            onFileStatusChange: _.bind(this.dataChanged, this),
            onDrop: _.bind(this.dataChanged, this),
            afterDelete: _.bind(this.dataChanged, this)
        });
    },
    dataChanged: function () {
        let uploadCount = _.size(this.model.uploads.models),
            hasUploads = uploadCount > 0,
            queued = 0,
            uploading = 0,
            success = 0;
        _.each(this.model.uploads.models, function (upload) {
            switch (upload.get('status')) {
                case 'queued':
                    queued++;
                    break;
                case 'uploading':
                    uploading++;
                    break;
                case 'success':
                    success++;
                    break;
            }

            let $queued = $('<span class="text-primary mr-2">Queued: ' + queued.toString() + '</span>');
            if (queued === 0) {
                $queued.addClass('op-6 font-weight-light');
            }

            let $uploaded = $('<span class="text-orange mr-2">Uploading: ' + uploading.toString() + '</span>');
            if (uploading === 0) {
                $uploaded.addClass('op-6 font-weight-light');
            }


            let $success = $('<span class="text-success">Uploaded: ' + success.toString() + '</span>');
            if (success === 0) {
                $success.addClass('op-6 font-weight-light');
            }

            this.$('.upload-files-status').empty().append([$queued, $uploaded, $success]);
        }, this);
        this.$('.btn-next-step').prop('disabled', !hasUploads || this.fileUploader.isUploading());
    },
    initBatchWait: function () {
        if (this.model.get('status') === 0 || this.model.get('status') === 1) {
            this.checkBatchStatus();
        } else {
            this.options.step++;
            this.render();
        }
    },
    initBatchPublish: function () {
        this.refreshTags();

        this.drawingVersionCounts = {};
        this.fullSet = null;

        _.each(_.filter(this.model.drawings.models, _.bind(function (drawing) {
            return !drawing.get('isPublished');
        }), this), _.bind(function (drawing) {

            if (_.size(drawing.get('name')) > 0 && _.size(drawing.get('tags')) == 0) {
                let matchedDrawing = null;
                _.each(this.options.versions.models, function (version) {
                    if (matchedDrawing == null) {
                        _.each(version.drawings.models, function (model) {
                            if (model.get('name') === drawing.get('name') && matchedDrawing == null && _.size(model.get('tags')) > 0) {
                                matchedDrawing = model;
                                drawing.set('tags', matchedDrawing.get('tags'));
                            }
                        });
                    }
                });
            }

            this.renderBatchDrawing(drawing);
        }, this));
        this.renderBatchDrawingAutoCompletes();

        this.renderReplaceCurrentSet();

        PJQ.app.lazyLoad().update();
    },
    renderBatchDrawingAutoCompletes: function () {
        new PJQ.inputs.AutocompleteInput({
            el: this.$('.input-drawing-name'),
            onSelect: (sel) => {
                this.drawingNameChanged(sel.e);
            },
            source: (req, res) => {
                if (_.size(req.term) === 0) {
                    return [];
                }
                res(_.filter(this.names, function (name) {
                    if (name.toLowerCase().indexOf(req.term.toLowerCase()) !== -1) {
                        return name;
                    }
                }));
            }
        });

        if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWING_HIDE_TAG)) {
            new PJQ.inputs.AutocompleteInput({
                el: this.$('.input-drawing-tag'),
                source: _.bind(function (req, res) {
                    if (_.size(req.term) === 0) {
                        return [];
                    }
                    res(_.filter(this.options.tags, function (tag) {
                        if (tag.toLowerCase().indexOf(req.term.toLowerCase()) !== -1) {
                            return tag;
                        }
                    }));
                }, this)
            });
        }
    },
    getBatchDrawingElement: function (drawing) {
        return this.$('.batch-drawing[data-cid="' + drawing.cid + '"]')
    },
    renderBatchDrawing: function (drawing) {
        if (this.fullSet == null) {
            this.fullSet = this.options.versions.getUniqueDrawings();
            this.names = [];
            _.each(this.fullSet, _.bind(function (fullSetDrawing) {
                let drawingName = fullSetDrawing.get('name');
                if (this.names.indexOf(drawingName) === -1) {
                    this.names.push(drawingName);
                }
            }, this));
        }

        let $drawing = this.getBatchDrawingElement(drawing),
            $header = $drawing.find('.drawing-details-header');

        let inCurrentSet = false,
            curSet = this.options.versions.get(-1);
        if (curSet != null) {
            inCurrentSet = curSet.drawings.findWhere({name: drawing.get('name')}) != null;
        }
        this.drawingVersionCounts[drawing.cid] = this.options.versions.getVersionStatsForDrawing(drawing);
        if (!this.drawingVersionCounts[drawing.cid].same) {
            drawing.set('keepExisting', false);
        }

        this.renderSubTemplate(false, this.options.subTemplates.drawingDetailHeader, $header, {
            inCurrentSet: inCurrentSet,
            versionCount: this.drawingVersionCounts[drawing.cid],
            drawing: drawing
        });

        this.renderDrawingTags(drawing);

        this.renderBatchHeader();
    },
    renderBatchHeader: function () {
        let newCount = 0,
            revisedCount = 0;
        _.each(this.drawingVersionCounts, function (count, cid) {
            let drawing = this.model.drawings.get(cid);
            if (drawing == null || drawing.get('isDeleted')) {
                return;
            }

            if (count.older + count.newer > 0) {
                revisedCount++;
            } else {
                newCount++;
            }
        }, this);
        this.renderSubTemplate(false, this.options.subTemplates.batchHeader, this.$('.batch-header'), {
            currentSetDefault: this.options.currentSetDefault,
            replaceCurrentSet: this.model.get('replaceCurrentSet'),
            newCount: newCount,
            revisedCount: revisedCount,
            totalCount: newCount + revisedCount
        });
    },
    initBatchSort: function () {
        this.sortDrawingsView = new PJQ.views.drawings.SortDrawings({
            el: this.$('.sort-drawings'),
            batch: this.model,
            versions: this.options.versions,
            afterRender: () => {
                this.$('.drawings-sort').css('height', parseInt(this.$('.modal-body').css('min-height')) - 220);
            }
        });
    },
    checkBatchStatus: function () {
        this.model.fetchStatus(_.bind(function (status) {
            if (status === 0 || status === 1) {
                this.model.statusTimeout = setTimeout(_.bind(function () {
                    this.checkBatchStatus();
                }, this), 2000);
            } else {
                this.model.fetch({
                    success: _.bind(function () {
                        this.setCurrentSetDefaults();
                        this.render();
                    }, this)
                });
            }
        }, this));
    },
    viewUploadLog: function () {
        this.close();
        new PJQ.views.drawings.DrawingUploadLogModal({
            project: this.options.project,
            versions: this.options.versions
        });
    },
    validateNewVersion: function (onSave = false) {
        let $name = this.$('.input-version-name'),
            versionNameExists = false,
            isNameValid = !onSave || _.size(this.model.version.get('name')) > 0,
            $issuedOn = this.$('.input-version-date-issued'),
            isIssuedValid = !onSave || this.model.version.get('issuedOn') != null;

        let newerVersionCount = 0;
        _.each(this.options.versions.models, _.bind(function (version) {
            if (new Date(this.model.version.get('issuedOn')) < new Date(version.get('issuedOn'))) {
                newerVersionCount++;
            }

            if (this.model.version.get('name').toLowerCase() === version.get('name').toLowerCase()) {
                versionNameExists = true;
            }
        }, this));
        isNameValid = isNameValid && !versionNameExists;

        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
        PJQ.helpers.inputHelpers.setInputError($issuedOn, isIssuedValid);

        let errors = '';
        if (newerVersionCount > 0) {
            errors += '<div class="text-info">There are ' + newerVersionCount.toString() + ' versions newer than this</div>';
        }
        if (versionNameExists) {
            errors += '<div class="text-danger">There is already a version with this name</div>';
        }
        this.$('.new-version-errors').html('<div>' + errors + '</div>');

        return isNameValid && isIssuedValid;
    },
    previousStep: function () {
        // this should only be allowed when going back from sorting to naming
        this.options.step--;
        this.render();
    },
    nextStep: function () {
        switch (this.options.step) {
            case 1:
                let hasFiles = _.size(this.model.files.models) > 0;
                if (this.model.version.isNew()) {
                    let isValid = this.validateNewVersion(true);
                    if (isValid) {
                        this.options.versions.add(this.model.version);
                        this.model.version.save(null, {
                            success: _.bind(function () {
                                if (hasFiles) {
                                    //skip the upload step
                                    this.options.step = this.options.step + 2;
                                    this.model.save(null, {
                                        success: _.bind(function () {
                                            this.render();
                                        }, this)
                                    });
                                } else {
                                    this.options.step++;
                                    this.render();
                                }
                            }, this)
                        });
                    }
                } else if (hasFiles) {
                    //skip the upload step
                    this.options.step = this.options.step + 2;
                    this.model.save(null, {
                        success: _.bind(function () {
                            this.render();
                        }, this)
                    });
                } else {
                    this.options.step++;
                    this.render();
                }
                break;
            case 2:
                this.model.save({
                    guid: this.fileUploader.options.uuid
                }, {
                    success: _.bind(function () {
                        this.options.step++;
                        this.render();
                    }, this)
                });
                break;
            case 4:
                let invalidDrawings = [];
                _.each(this.model.drawings.models, function (drawing) {
                    if (drawing.get('isDeleted')) {
                        return;
                    }

                    let isValid = true;
                    if (_.find(this.model.drawings.models, function (existingDrawing) {
                        return existingDrawing.get('name') === drawing.get('name') && existingDrawing.id !== drawing.id && !existingDrawing.get('isDeleted');
                    }) != null) {
                        invalidDrawings.push(drawing);
                        isValid = false;
                    }
                    let $drawing = this.getBatchDrawingElement(drawing);
                    PJQ.helpers.inputHelpers.setInputError($drawing.find('.input-drawing-name'), isValid);
                }, this);

                if (_.size(invalidDrawings) > 0) {
                    this.setBatchError("Some drawings have duplicated names, please fix these before finalizing");
                } else {
                    this.setBatchError();
                    this.options.step++;
                    this.render();
                }
                break;
            default:
                this.options.step++;
                this.render();
                break;
        }
    },
    setBatchError: function (error) {
        let $err = this.$('.batch-error');
        if (error != null) {
            $err.html(error);
        } else {
            $err.empty();
        }
    },
    versionNameChanged: function (e) {
        let val = $(e.currentTarget).val(),
            valLen = _.size(val);
        if (valLen > 0 && e.keyCode === 13) {
            this.nextStep();
            return;
        }
        this.model.version.set("name", val);
        this.$(".btn-next-step").prop('disabled', valLen === 0);
        this.validateNewVersion();
    },
    useNewVersion: function () {
        this.$('.checkbox-new-version').prop('checked', true);
        this.$('.checkbox-existing-version').prop('checked', false);
        this.$('.new-version').removeClass('disabled');
        this.$('.existing-versions').addClass('disabled');
        this.model.version = new PJQ.models.drawings.Version({
            projectId: this.options.project.id,
            name: this.$('.input-version-name').val()
        });
    },
    useExistingVersion: function () {
        this.$('.checkbox-existing-version').prop('checked', true);
        this.$('.checkbox-new-version').prop('checked', false);
        this.$('.existing-versions').removeClass('disabled');
        this.$('.new-version').addClass('disabled');
        this.$(".btn-next-step").prop('disabled', false);
        this.model.version = this.options.versions.get(this.$('.existing-version.selected').data('cid'));
    },
    existingVersionSelected: function (e) {
        let $target = $(e.currentTarget);
        this.$('.existing-version').removeClass('selected');
        $target.addClass('selected');
        this.model.version = this.options.versions.get($target.data('cid'));
    },
    viewBatchDrawing: function (e) {
        this.$el.addClass('hidden');

        let $drawing = $(e.currentTarget).closest('.batch-drawing'),
            cid = $drawing.data('cid'),
            drawing = this.model.drawings.get(cid);
        new PJQ.views.drawings.DrawingViewer({
            model: drawing,
            batch: this.model,
            showSortableViewLink: false,
            isEdit: true,
            versions: this.options.versions,
            onClose: (changed) => {
                this.$el.removeClass('hidden');
                if (changed) {
                    this.render();
                }
            }
        });
    },
    rotateBatchDrawing90Clicked: function (e) {
        let $row = $(e.currentTarget).closest('.batch-drawing'),
            cid = $row.data('cid'),
            drawing = this.model.drawings.get(cid);
        this.rotateDrawing(drawing, 90);
    },
    rotateBatchDrawing180Clicked: function (e) {
        let $row = $(e.currentTarget).closest('.batch-drawing'),
            cid = $row.data('cid'),
            drawing = this.model.drawings.get(cid);
        this.rotateDrawing(drawing, 180);
    },
    rotateBatchDrawing270Clicked: function (e) {
        let $row = $(e.currentTarget).closest('.batch-drawing'),
            cid = $row.data('cid'),
            drawing = this.model.drawings.get(cid);
        this.rotateDrawing(drawing, 270);
    },
    rotateDrawing: function (drawing, degrees) {
        let $drawing = this.getBatchDrawingElement(drawing),
            rotateLoader = new PJQ.Loader($drawing);
        drawing.rotate(degrees, _.bind(function () {
            rotateLoader.remove();
            $drawing.find('.batch-drawing-thumb').attr('src', drawing.thumbUrl());
            $drawing.find('.batch-drawing-crop').attr('src', drawing.cropUrl());
            this.renderBatchDrawing(drawing);
        }, this));
    },
    deleteBatchDrawing: function (e) {
        let $row = $(e.currentTarget).closest('.batch-drawing'),
            cid = $row.data('cid'),
            drawing = this.model.drawings.get(cid);
        drawing.set('isDeleted', true);
        $row.remove();
        this.renderBatchHeader();
    },
    drawingBlur: function () {
        this.$('.batch-drawing').removeClass('focus');
    },
    drawingFocus: function (e) {
        let $target = $(e.currentTarget),
            $drawing = $target.closest('.batch-drawing');
        this.drawingBlur();
        $drawing.addClass('focus');
        $target.select();
    },
    drawingCenter: function ($drawing) {
        this.$el.scrollTop($drawing.position().top - $drawing.height())
    },
    drawingNameKeydown: function (e) {
        let $drawing = $(e.currentTarget).closest('.batch-drawing');
        if (e.which === 13 || (e.shiftKey && e.which === 40)) {
            let $next = this.nextDrawing($drawing);
            if (_.size($next) > 0) {
                $next.find('.input-drawing-name').focus();
            } else {
                this.firstDrawing().find('.input-drawing-title').focus();
            }
        } else if (e.shiftKey && (e.which === 8 || e.which === 38)) {
            let $prev = this.prevDrawing($drawing);
            $prev.find('.input-drawing-name').focus();
        }
    },
    drawingNameChanged: function (e) {
        let $target = $(e.target),
            $drawing = $target.closest('.batch-drawing'),
            cid = $drawing.data('cid'),
            drawing = this.model.drawings.get(cid),
            name = $target.val(),
            matchedDrawing = null;
        _.each(this.options.versions.models, function (version) {
            if (matchedDrawing == null) {
                _.each(version.drawings.models, function (drawing) {
                    if (drawing.get('name') === name && (matchedDrawing == null || _.size(matchedDrawing.get('title')) === 0)) {
                        matchedDrawing = drawing;
                    }
                });
            }
        });

        if (matchedDrawing != null) {
            let title = matchedDrawing.get('title'),
                tags = matchedDrawing.get('tags');
            drawing.set({
                name: name,
                title: title,
                tags: tags
            });
            $drawing.find('.input-drawing-title').val(title);
            this.renderDrawingTags(drawing, null);
        } else {
            drawing.set({
                name: name
            });
        }

        this.renderBatchDrawing(drawing);
    },
    drawingTitleKeydown: function (e) {
        let $drawing = $(e.currentTarget).closest('.batch-drawing');
        if (e.which === 13 || (e.shiftKey && e.which === 40)) {
            let $next = this.nextDrawing($drawing);
            if (_.size($next) > 0) {
                $next.find('.input-drawing-title').focus();
            } else {
                this.firstDrawing().find('.input-drawing-tag').focus();
            }
        } else if (e.shiftKey && (e.which === 8 || e.which === 38)) {
            let $prev = this.prevDrawing($drawing);
            $prev.find('.input-drawing-title').focus();
            return false;
        }
    },
    drawingTitleChanged: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.closest('.batch-drawing').data('cid'),
            drawing = this.model.drawings.get(cid);
        drawing.set('title', $target.val());
    },
    drawingTagKeydown: function (e) {
        let $target = $(e.currentTarget),
            tag = $target.val(),
            $drawing = $target.closest('.batch-drawing'),
            drawing = this.model.drawings.get($drawing.data('cid'));
        if (e.shiftKey && (e.which === 13 || e.which === 40)) {
            let $next = this.nextDrawing($drawing);
            $next.find('.input-drawing-tag').focus();
            return false;
        } else if (e.shiftKey && (e.which === 8 || e.which === 38)) {
            let $prev = this.prevDrawing($drawing);
            $prev.find('.input-drawing-tag').focus();
            return false;
        } else if (e.which === 13) {
            this.addDrawingTags(drawing, tag);
            $target.val('');
            return false;
        } else if (e.which === 9) {
            this.nextDrawing($drawing);
        }
    },
    firstDrawing: function () {
        let $firstDrawing = this.$('.batch-drawing').first();
        this.drawingCenter($firstDrawing);
        return $firstDrawing;
    },
    prevDrawing: function ($drawing) {
        let $prevDrawing = $drawing.prev();
        if (_.size($prevDrawing) > 0) {
            this.drawingCenter($prevDrawing);
        }
        return $prevDrawing;
    },
    nextDrawing: function ($drawing) {
        let $nextDrawing = $drawing.next();
        if (_.size($nextDrawing) > 0) {
            this.drawingCenter($nextDrawing);
        }
        return $nextDrawing;
    },
    drawingTagChanged: function (e) {
        let $target = $(e.currentTarget);
        $target.siblings('.btn-add-drawing-tag').prop('disabled', _.size($target.val()) === 0);
    },
    addDrawingTagClicked: function (e) {
        let $target = $(e.currentTarget),
            $drawing = $target.closest('.batch-drawing'),
            $tag = $drawing.find('.input-drawing-tag'),
            tag = $tag.val();
        if (_.size(tag) > 0) {
            let drawing = this.model.drawings.get($drawing.data('cid'));
            this.addDrawingTags(drawing, tag);
            $tag.val('');
        }
    },
    deleteTagClicked: function (e) {
        let $target = $(e.currentTarget),
            tagName = $target.closest('.drawing-tag').data('name'),
            $drawing = $target.closest('.batch-drawing'),
            drawing = this.model.drawings.get($drawing.data('cid'));
        drawing.deleteTag(tagName, null, _.bind(function () {
            this.refreshTags();
            this.renderDrawingTags(drawing, _.bind(function ($drawing) {
                $drawing.find('.input-drawing-tag').focus();
            }, this));
        }, this));
    },
    addDrawingTags: function (drawing, tag) {
        let tags = [];
        if (_.size(tag) > 0) {
            _.each(tag.split(','), function (tag) {
                let tagTrim = tag.trim();
                if (_.size(tagTrim) > 0) {
                    tags.push(tagTrim);
                }
            });
        }

        drawing.addTags(tags, {
            save: false
        }, _.bind(function () {
            this.refreshTags();
            this.renderDrawingTags(drawing, _.bind(function ($drawing) {
                $drawing.find('.input-drawing-tag').focus();
            }, this));
        }, this));
    },
    renderDrawingTags: function (drawing, callback) {
        let $drawing = this.getBatchDrawingElement(drawing);
        this.renderSubTemplate(false, this.options.subTemplates.drawingTags, $drawing.find('.drawing-tags'), {
            tags: drawing.get('tags')
        }, function () {
            if (typeof callback === 'function') {
                callback($drawing);
            }
        });
    },
    refreshTags: function () {
        let batchTags = [];
        _.each(this.model.drawings.models, function (drawing) {
            let drawingTags = drawing.get('tags');
            if (_.size(drawingTags) > 0) {
                batchTags.push(...drawingTags);
            }
        });

        this.options.tags = [];
        _.each(_.union(_.uniq(batchTags), this.options.versions.getDrawingTags()), _.bind(function (tag) {
            if (_.size(tag) > 0 && this.options.tags.indexOf(tag) === -1) {
                this.options.tags.push(tag);
            }
        }, this));
    },
    addAllToCurrentSetChanged: function (e) {
        this.addAllToCurrent($(e.currentTarget).prop('checked'));
    },
    addAllToCurrent: function (shouldAdd) {
        this.$('.checkbox-add-all-current-set,.checkbox-add-current-set').prop('checked', shouldAdd);
        _.each(this.model.drawings.models, function (drawing) {
            drawing.set('isCurrentSet', shouldAdd);
        });
    },
    replaceCurrentSetChanged: function (e) {
        let $target = $(e.currentTarget),
            replaceCurrent = $target.prop('checked');
        this.model.set('replaceCurrentSet', replaceCurrent);
        this.addAllToCurrent(true);
        this.renderReplaceCurrentSet();
    },
    renderReplaceCurrentSet: function () {
        this.$('.checkbox-add-all-current-set,.checkbox-add-current-set').prop('disabled', this.model.get('replaceCurrentSet'));
    },
    addToCurrentSetChanged: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.closest('.batch-drawing').data('cid'),
            drawing = this.model.drawings.get(cid),
            addCurrent = $target.prop('checked');

        drawing.set('isCurrentSet', addCurrent);

        if (!addCurrent) {
            this.$('.checkbox-add-all-current-set').prop('checked', false);
        }
    },
    replaceExistingDrawingChanged: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.closest('.batch-drawing').data('cid'),
            drawing = this.model.drawings.get(cid),
            replaceExisting = $target.prop('checked');
        drawing.set('keepExisting', !replaceExisting);
    },
    cancel: function () {
        if (this.options.step === 4 || this.options.step === 5) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    closeModal: function () {
        this.removeModal();
        if (this.model.statusTimeout != null) {
            clearTimeout(this.model.statusTimeout);
            this.model.statusTimeout = null;
        }
    },
    close: function () {
        if (this.options.step === 3) {
            this.closeModal();
        } else {
            this.cancel();
        }
    },
    save: function () {
        this.model.save(null, {
            success: _.bind(function () {
                this.removeModal();
            }, this)
        });
    },
    autoNotify: function (callback) {
        let verAppend = null,
            verName = '';
        if (this.options.versions != null) {
            let version = this.options.versions.get(this.model.get('versionId'));
            if (version != null) {
                verName = version.get('name');
                verAppend = ' (' + verName + ')';
            }
        }

        this.model = new PJQ.models.drawings.DrawingBatchNotification({
            batchId: this.model.id,
            subject: 'Drawings Published to ' + this.options.project.get('projectName') + (verAppend ?? ""),
            message: 'New drawings have been published to ' + this.options.project.get('projectName') + ' - <b>Version:</b> ' + verName + '.',
            allProjectContacts: true
        });
        this.model.save(null, {
            notify: false,
            success: () => {
                callback();
            },
            error: () => {
                callback();
            }
        });
    },
    publish: function (callback) {
        let hasNonCurSetPublish = _.find(this.model.drawings.models, function (drawing) {
                return drawing.get('versionId') === this.model.get('versionId') && drawing.get('isCurrentSet') === false;
            }, this) != null,
            fnPublish = (billRawFileUploadId, billDeerfieldTicketId, notes) => {
                new PJQ.Loader(this.$('.modal-content'));
                this.model.save(null, {
                    urlOptions: {
                        publish: true,
                        billRawFileUploadId: billRawFileUploadId,
                        billDeerfieldTicketId: billDeerfieldTicketId,
                        notes: notes
                    },
                    success: () => {
                        if ((billRawFileUploadId > 0 || billDeerfieldTicketId > 0) && this.model.get('docClerkOrderId') > 0) {
                            new PJQ.views.BaseModal({
                                header: "Doc Clerk Order Created",
                                body: 'The Order ID is ' + this.model.get('docClerkOrderId'),
                                isShowCancelButton: false
                            });
                        }

                        this.autoNotify(() => {
                            this.options.versions.fetch({
                                success: () => {
                                    this.removeModal();

                                    if (typeof callback === 'function') {
                                        callback();
                                    }
                                }
                            });
                        });
                    }
                });
            },
            fnPrePublish = _.bind(function () {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK) && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_RAW_FILE_UPLOAD_BILLING)) {
                    new PJQ.views.drawings.RawFileUploadBilling({
                        onContinue: _.bind(function (rawFileUploadId, deerfieldTicketId, notes) {
                            fnPublish(rawFileUploadId, deerfieldTicketId, notes);
                        }, this),
                        onSkip: _.bind(function () {
                            fnPublish();
                        }, this)
                    });
                } else
                    fnPublish();
            }, this);

        if (hasNonCurSetPublish) {
            new PJQ.views.BaseModal({
                header: "Confirm Publish",
                okButtonText: "Confirm",
                isShowSecondaryButton: true,
                secondaryButtonText: "Cancel",
                body: "You have selected for some drawings to not be published as part of the current set.  Please confirm this selection.",
                onOk: _.bind(function () {
                    fnPrePublish();
                }, this)
            });
        } else {
            fnPrePublish();
        }
    }
});

PJQ.views.drawings.RawFileUploadBilling = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Raw-File-Upload-Billing'),
        onSkip: _.noop(),
        onContinue: _.noop()
    },
    events: {
        'click .billing-skip': 'skipBilling',
        'click .billing-continue': 'continueBilling'
    },
    afterRender: function () {
        this.$('.billing-id').inputmask({
            alias: "integer",
            prefix: "",
            digits: 0,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false
        });

        this.billingReferenceSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.billing-reference'),
            isIntChoices: false,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: 'rawFileUploadId'
        });
    },
    skipBilling: function () {
        if (typeof this.options.onSkip === 'function') {
            this.options.onSkip();
            this.removeModal();
        } else
            this.removeModal();
    },
    continueBilling: function () {
        let rawFileUploadId = 0,
            deerfieldTicketId = 0;

        if (this.billingReferenceSelectPicker.getValue() === 'rawFileUploadId')
            rawFileUploadId = parseInt(this.$('.billing-id').val());
        else
            deerfieldTicketId = parseInt(this.$('.billing-id').val());

        let rawFileUpload = new PJQ.models.rawFileUploads.RawFileUpload({
            rawFileUploadId: rawFileUploadId,
            projectId: PJQ.app.session.project.id
        });

        if (rawFileUploadId > 0) {
            rawFileUpload.fetch({
                success: _.bind(function () {
                    this.options.onContinue(rawFileUpload.id, null, this.$('.notes').val());
                    this.removeModal();
                }, this),
                error: _.bind(function () {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Raw Upload Id not found, or does not match this Project.'
                    });
                }, this)
            });
        } else if (deerfieldTicketId > 0) {
            this.options.onContinue(null, deerfieldTicketId, this.$('.notes').val());
            this.removeModal();
        } else {
            PJQ.notifications.notify.errorNotify({
                message: 'Enter Raw Upload Id or Deerfield Ticket Id to continue.'
            });
        }
    }
});